import React from 'react';
import { useTranslation } from 'react-i18next';
import './curve-theme.css';

export type ArchiveFilterValue = 'active' | 'archived' | 'all';

type ArchiveFilterProps = {
  value: ArchiveFilterValue;
  onChange: (value: ArchiveFilterValue) => void;
};

export function ArchiveFilter({ value, onChange }: ArchiveFilterProps) {
  const { t } = useTranslation();
  const OPTIONS: { id: ArchiveFilterValue; label: string }[] = [
    { id: 'active', label: t('SearchBar.archive_active') },
    { id: 'archived', label: t('SearchBar.archive_archived') },
    { id: 'all', label: t('SearchBar.archive_all') },
  ];

  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value as ArchiveFilterValue)}
      style={{
        height: '28px',
        border: '1px solid var(--curve-border, #E5E5E5)',
        borderRadius: 'var(--curve-radius-sm, 4px)',
        padding: '0 6px',
        fontSize: 'var(--curve-text-xs, 12px)',
        color: 'var(--curve-text-dark, #1E293B)',
        background: 'var(--curve-bg-white, #FFFFFF)',
        cursor: 'pointer',
        outline: 'none',
        flexShrink: 0,
        appearance: 'auto',
      }}
    >
      {OPTIONS.map((opt) => (
        <option key={opt.id} value={opt.id}>
          {opt.label}
        </option>
      ))}
    </select>
  );
}
